import { Container } from 'Components/Container';
import { TitleForm } from 'Components/Form/styles';
import { Row } from 'Components/Grid';
import { useNavigate } from 'react-router-dom';
import { GenerateNewReportRopa } from './Details';
import { FormSuccess } from 'Components/Form/Success';
import { useSelector } from 'react-redux';
import { useAuthTenant } from 'store/auth';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { addRopa } from 'services/report-ropa-service';
import { PageHelper } from 'Components/PageHelper';

export const ReportsRopaForm = () => {
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const navigate = useNavigate();
  const [finished, setFinished] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      name: '',
      scope: '',
      areaId: '',
      processId: '',
      companyKey: selectedTenant.slug,
    },
  });

  const handleComplete = async () => {
    try {
      const res = await addRopa(getValues());
      if (res.status === 200 || res.status === 201) {
        setFinished(true);
      } else {
        throw new Error('Ocorreu um erro ao tentar salvar/editar o Escritório!');
      }
    } catch (error) {
      SwalReact.fire({
        title: 'Erro!',
        html: error.response.data.message ?? error.message,
        icon: 'error',
      });
    }
  };

  const handleReset = () => {
    reset();
    setFinished(false);
  };

  return (
    <Container title={`Gerar Novo Relatório`} breadcrumb="Gerenciar / Escritórios" linkPage="/reports/ropa">
      <div className="card-content">
        <Row>
          <TitleForm data-tour="form-title">Gerar Novo Relatório</TitleForm>
        </Row>
        {!finished && (
          <GenerateNewReportRopa
            control={control}
            register={register}
            handleComplete={handleComplete}
            handleSubmit={handleSubmit}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
            selectedTenant={selectedTenant}
          />
        )}
        {finished && (
          <FormSuccess
            title="Relatório Ropa cadastrado com sucesso!"
            labelStartAgain="Cadastrar Novo Relatório Ropa"
            handleStartAgain={() => handleReset()}
            labelShow="Ok"
            handleShow={() => navigate('/reports/ropa')}
          />
        )}
      </div>
      {!finished && <PageHelper steps={tourSteps} tourKey="reports-ropa-form" />}
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo ao formulário de geração de Relatório ROPA! Este relatório documenta todas as operações de processamento de dados conforme exigido pela LGPD.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: 'body',
    content: 'Aqui você configura os parâmetros para gerar seu relatório ROPA.',
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="report-name"]',
    content: 'Digite um nome descritivo para identificar este relatório ROPA. Use um nome que facilite a localização futura.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="report-scope"]',
    content: 'Selecione o escopo do relatório: Empresa (toda organização), Área (departamento específico), Processo (atividade específica) ou Sumário Executivo.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="form-actions"]',
    content: 'Use "Cancelar" para descartar as alterações ou "Salvar" para gerar o relatório ROPA com as configurações definidas.',
    disableScrolling: true,
  },
  {
    target: 'body',
    content: 'Tour concluído! Preencha os campos e gere seu relatório ROPA para manter a documentação de conformidade com a LGPD atualizada.',
    disableScrolling: true,
    placement: 'center',
  },
];
